import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import { Commit } from "vuex";

interface ExploitedDomainsSettings {
  status: {
    value: boolean;
    inherited_from: string | null;
  };
}

interface ExploitedDomainsState {
  settings?: ExploitedDomainsSettings;
}

const state: ExploitedDomainsState = {
  settings: undefined,
};

const getters = {
  settingsStatus: (state: ExploitedDomainsState) =>
    state.settings?.status.value,
};

const actions = {
  async getExploitedDomainsSettings(
    { commit }: { commit: Commit },
    {
      organisationID,
    }: {
      organisationID: string;
    },
  ) {
    const res = await $http.get(
      `${getApiClientUrl()}/v1/pt/settings/${organisationID}/suspicious-domains`,
    );

    commit("setExploitedDomainsSettings", res.data);
  },
  async putExploitedDomainsSettings(
    { commit }: { commit: Commit },
    {
      organisationID,
      status,
    }: {
      organisationID: string;
      status: boolean;
    },
  ) {
    const res = await $http.put(
      `${getApiClientUrl()}/v1/pt/settings/${organisationID}/suspicious-domains`,
      {
        status,
      },
      { _hasCustomErrorHandling: true },
    );

    commit("setExploitedDomainsSettings", res.data);
  },
};

const mutations = {
  setExploitedDomainsSettings: (
    state: ExploitedDomainsState,
    data: ExploitedDomainsSettings,
  ) => (state.settings = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
